<template>
    <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-400 to-indigo-600">
        <!-- Full page loader -->
        <div v-if="loading" class="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center">
            <div class="h-12 w-12 border-4 border-orange-500 border-dashed rounded-full animate-spin"></div>
        </div>
        <!-- App content wrapper (disabled while loading) -->
        <div :class="{ 'pointer-events-none select-none opacity-50': loading }"
            class="w-full max-w-4xl bg-white shadow-xl rounded-2xl flex overflow-hidden">
            <div class="hidden md:block w-1/2 bg-cover bg-center"
                :style="{ backgroundImage: 'url(/storage/default/auth-bg.jpg)' }"></div>

            <div class="w-full md:w-1/2 p-8">
                <slot name="logo" />
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>
